import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, Search, ChevronLeft } from 'lucide-react';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div
      data-testid="not-found-page"
      className="min-h-[70vh] flex items-center justify-center bg-slate-50 px-4"
    >
      <div className="max-w-lg w-full text-center">
        <div className="text-8xl font-extrabold text-emerald-600 mb-4">404</div>
        <h1 className="text-3xl font-bold text-slate-900 mb-3">Sayfa Bulunamadı</h1>
        <p className="text-slate-600 mb-8">
          Aradığınız sayfa mevcut değil, taşınmış ya da adres yanlış yazılmış olabilir.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            data-testid="notfound-home-btn"
            onClick={() => navigate('/')}
            className="bg-emerald-600 hover:bg-emerald-700"
          >
            <Home className="w-4 h-4 mr-2" />
            Ana Sayfa
          </Button>
          <Button
            data-testid="notfound-facilities-btn"
            variant="outline"
            onClick={() => navigate('/tesisler')}
          >
            <Search className="w-4 h-4 mr-2" />
            Tesisleri Keşfet
          </Button>
          <Button
            data-testid="notfound-back-btn"
            variant="ghost"
            onClick={() => navigate(-1)}
          >
            <ChevronLeft className="w-4 h-4 mr-2" />
            Geri
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
